/** Dialog ids registered with `risa-oasis-ui_v2` modal helpers. */
export enum ModalId {
  MANUAL_ATOM_OVERRIDE_MODAL = "clinical-trials-manual-atom-override-modal",
  PATIENT_STATUS_CHANGE_MODAL = "clinical-trials-patient-status-change-modal",
  VIEW_EVIDENCE_MODAL = "clinical-trials-view-evidence-modal",
  ADD_MONITORING_TRIAL_MODAL = "clinical-trials-add-monitoring-trial-modal",
  CRITERIA_EVALUATION_MODAL = "clinical-trials-criteria-evaluation-modal",
}
